import React from 'react';

export const LayoutTopBar: React.FC<{children: React.ReactNode}> = ({ children }) => {
  return <>{children}</>;
};
